module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"prop-header\"><span class=\"prop-label\">Set Next Stage Settings</span></div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-12 subsection nopadding-r\">\r\n        <label class=\"prop-sublabel label-40\">Stage</label> \r\n        <div>\r\n            <select name=\"stageId\" id=\"nextStage\">\r\n                <option value=\"\"></option>\r\n                    ")
    ;  stages.map(function(stage) { 
    ; __append("\r\n                        <option value=\"")
    ; __append(escapeFn(stage.id))
    ; __append("\">")
    ; __append(escapeFn(stage.model.get('name')))
    ; __append("</option>\r\n                    ")
    ; 
                    });
                
    ; __append("\r\n            </select>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n\r\n\r\n")
  }
  return __output;

}